module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor03.51d695d2.png";